/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./InventoryTable.vue?vue&type=template&id=146c100f"
import script from "./InventoryTable.vue?vue&type=script&lang=js"
export * from "./InventoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('146c100f')) {
      api.createRecord('146c100f', component.options)
    } else {
      api.reload('146c100f', component.options)
    }
    module.hot.accept("./InventoryTable.vue?vue&type=template&id=146c100f", function () {
      api.rerender('146c100f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/inventory/InventoryTable.vue"
export default component.exports